/// <reference path="../typings/index.d.ts" />
/// <reference path="CampoNoUiSlider.d.ts" />

namespace App {
  export class CampoNoUiSlider implements ICampoNoUiSlider {
    public inicializarCampo(seletorId: string | any, elementoInput: JQuery, range: any, direction: string = null, snap: boolean = true, density: number = 50, mode: string = 'steps', connect: boolean = true): any {
      var campoNoUiSlider: any = typeof seletorId === 'object' ? seletorId : document.getElementById(seletorId);
      var arrayLabelsCustom: any = null;

      if (elementoInput.data('arrayLabelsCustom')) {
        arrayLabelsCustom = App.Util.stringParseJsonObject(elementoInput.data('arrayLabelsCustom'));
      }

      noUiSlider.create(campoNoUiSlider, {
        start: elementoInput.val(),
        range: range,
        direction: direction,
        snap: snap,
        connect: connect,
        pips: {
          mode: mode,
          format: {
            to: function (value: any) {
              if (arrayLabelsCustom) {
                var item = arrayLabelsCustom.find((el: any) => el.value == value);
                return item.name;
              }
              return value;
            },
            from: function (value: any) {
              if (arrayLabelsCustom) {
                var item = arrayLabelsCustom.find((el: any) => el.name == value);
                return item.value;
              }
              return value;
            }
          },
          density: density
        }
      });

      return campoNoUiSlider;
    }


  }
}
